import NGOTransactionsLayout from 'features/ngo/transactions'
import React from 'react'

const NGOTransations = () => {
  return (
    <NGOTransactionsLayout />
  )
}

export default NGOTransations